<template>
  <div class="global-filter-summary">
    <p class="global-filter-summary__title">
      {{ $t('components.GlobalFilterSummary.label.title') }}
    </p>

    <GlobalFilterMenu
      class="global-filter-summary__global-filter-menu"
      :show-date-range="true"
      :read-only="true"
      :global-filter-by-data-type="globalFilterByDataType"
      :data-type="dataType"
    />
  </div>
</template>

<script>
import GlobalFilterMenu from '@/components/GlobalFilterMenu';

export default {
  name: 'GlobalFilterSummary',
  components: {
    GlobalFilterMenu,
  },
  props: {
    globalFilterByDataType: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    dataType: {
      type: String,
      require: true,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
  .global-filter-summary {
    width: 100%;
    padding: var(--ds-spacing-stack-xs) 0;
    background-color: rgba(var(--ds-color-reverse-rgba), 0.08);
    border-radius: 4px;

    &__title {
      color: var(--ds-color-text-2);
      font-weight: var(--ds-font-weight-semibold);
      font-size: 12px;
      line-height: var(--ds-font-size-baseline);
      margin: 0 var(--ds-spacing-stack-xs) var(--ds-spacing-stack-nano) var(--ds-spacing-stack-xs);
    }

    &__global-filter-menu {
      padding-top: 0;
      margin: 0 var(--ds-spacing-stack-xs) 0 var(--ds-spacing-stack-nano);
    }
  }
</style>
